module.exports = __webpack_public_path__ + "img/header-memoireRingsSlim@2x.0585ba2.webp";